import './Main.scss';
import Component from './Main.js';
export default Component;
